import React from "react";
import { Badge, colors } from "../design/badge";
import { FinancialItem } from "../models/FinancialItem";
import { Avatar } from "../design/avatar";

const OwnershipStatusBadge: React.FC<{
  ownershipStatus: FinancialItem["ownershipStatus"];
}> = ({ ownershipStatus }) => {
  let color;
  let title;
  switch (ownershipStatus) {
    case "separate":
      color = "green";
      title = "S";
      break;
    case "marital":
      color = "yellow";
      title = "M";
      break;
    default:
      color = "gray";
      title = ownershipStatus;
      break;
  }
  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default OwnershipStatusBadge;
